module.exports = __webpack_public_path__ + "static/img/blo2.53f8d68d.png";